<template>
  <div
    id="sendButton"
    :class="[isActiveClass || activeLoginBtn ? 'activeClass' : 'disableClass']"
    @click="sendCodeBtn()"
  >
    <p class="sendCode">{{ buttonText }}</p>
  </div>
</template>

<script>
export default {
  props: {
    buttonText: {
      // 按钮文本
      title: String,
      default: '发送验证码',
    },
    isActiveClass: {
      title: Boolean,
      default: null,
    },
    activeLoginBtn: {
      title: Boolean,
      default: null,
    },
    resetPassword: {
      type: String,
      default: null,
    },
    loginWay: {
      type: String,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      userPhone: '',
    };
  },
  methods: {
    sendCodeBtn() {
      switch (this.loginWay) {
        case 'registrationLogin':
          this.$emit('sendCodeBtn');
          break;
        case 'passworldLogin':
          this.$emit('sendCodeBtn');
          break;
        case 'forgetPassword':
          this.$emit('sendCodeBtn');
          break;
        case 'resetPassword':
          this.$emit('sendCodeBtn');
          break;
        default: {
          break;
        }
      }
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
#sendButton {
  width: 605px;
  height: 91px;
  margin: 0 auto;
  border-radius: 14px;

  p {
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 91px;
    text-align: center;
  }
}

.activeClass {
  background-color: #ff6c02;
}
.disableClass {
  color: #fff;
  background-color: #a5a5a5;
}
</style>
